import type { TargetPlace } from '@/types/gmb';
import { formatDateTime, orDash } from '@/pages/gmb-audit/utils/format';

export default function ResultSummaryHeader({ target }: { target: TargetPlace }) {
  const hasMapsLink = Boolean(target.mapsUrl && target.mapsUrl.trim().length > 0);

  return (
    <section className="w-full border-b border-slate-200 bg-slate-50/70">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-8 md:px-8 md:py-10">
        <p className="text-xs font-semibold uppercase tracking-wider text-teal-700">健診報告</p>
        <h1 className="mt-2 text-2xl font-bold text-slate-900 md:text-[2rem] md:leading-tight">
          {orDash(target.name)}
        </h1>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <div className="rounded-lg border border-slate-200 bg-white p-4">
            <p className="flex items-center gap-1.5 text-xs font-medium text-slate-500">
              <i className="ri-map-pin-line" />
              地址
            </p>
            <p className="mt-2 text-sm font-medium text-slate-900">{orDash(target.address)}</p>
          </div>

          <div className="rounded-lg border border-slate-200 bg-white p-4">
            <p className="flex items-center gap-1.5 text-xs font-medium text-slate-500">
              <i className="ri-price-tag-3-line" />
              主要類別
            </p>
            <p className="mt-2 text-sm font-medium text-slate-900">{orDash(target.primaryCategory)}</p>
          </div>

          <div className="rounded-lg border border-slate-200 bg-white p-4">
            <p className="flex items-center gap-1.5 text-xs font-medium text-slate-500">
              <i className="ri-time-line" />
              健診時間
            </p>
            <p className="mt-2 text-sm font-medium text-slate-900">{formatDateTime(target.auditedAt)}</p>
          </div>

          <div className="rounded-lg border border-slate-200 bg-white p-4">
            <p className="flex items-center gap-1.5 text-xs font-medium text-slate-500">
              <i className="ri-links-line" />
              Google Maps
            </p>
            {hasMapsLink ? (
              <a
                href={target.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 inline-flex cursor-pointer items-center gap-1.5 text-sm font-medium text-teal-700 hover:text-teal-800"
              >
                在地圖上查看
                <i className="ri-external-link-line" />
              </a>
            ) : (
              <p className="mt-2 text-sm font-medium text-slate-400">—</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}